/* Script of sections/custom-install-form-2.liquid, moved out of the section so browsers can cache it. OURS.
   Loaded with defer from the section; it still waits for DOMContentLoaded, which fires after deferred scripts run. */
document.addEventListener("DOMContentLoaded", function () {
  // Initialize variables and query DOM elements
  let currentPageIndex = 0;
  const pages = document.querySelectorAll(".mc-page");
  const progressBar = document.getElementById("progress-bar");
  const maxPageIndex = pages.length - 2; // [cite: 179] Second to last page is the submit page
  const akzeptierenButton = document.getElementById("weiter"); // [cite: 179]
  const zurückButton = document.getElementById("zurück"); // [cite: 180]
  const resetButton = document.getElementById("reset"); // [cite: 180]
  const finalForm = document.querySelector("form"); // [cite: 180]

  // ##################################################################
  // ### 💰 CENTRAL PRICE CONFIGURATION 💰 ###
  // ##################################################################
  // All pricing logic is now stored in this single object.
  // Modify values here to update the calculation everywhere.
  
  const priceConfig = {
    // Base prices for each product, matched by 'data-handle' in the HTML
    productPrices: {
      "ueberwachungskamera": 240.00,
      "video-tuerklingel": 220.00,
    },
    
    // Other associated costs
    costs: {
      // Anschlusspauschale per product
      "pauschalePerProduct": 50.00, 
      // SD card price for manually selected items
      "sdCardPrice": 19.99,
      // SD card price for "Weiß nicht" option
      "sdCardPriceWeissNicht": 15.99, 
    },

    // Rules for installation costs (Montagekosten)
    montageRates: {
      "1": { "rate": 500.00, "perProduct": false, "label": "1 Produkt (Pauschale)" },
      "2": { "rate": 350.00, "perProduct": true, "label": "2 Produkte @ 150.00 €" },
      "default": { "rate": 300.00, "perProduct": true, "label": "3+ Produkte @ 100.00 €" }
    },

    // Default product packages for the "Weiß nicht" (Don't know) option
    weissNichtDefaults: {
      // Key must match the text content of the property type button
      "Büro": {
        "ueberwachungskamera": 3,
        "video-tuerklingel": 1
      },
      "Wohnung": {
        "ueberwachungskamera": 1,
        "video-tuerklingel": 1
      },
      "Gewerbe": {
        "ueberwachungskamera": 2,
        "video-tuerklingel": 1
      },
      "Haus": {
        "ueberwachungskamera": 3,
        "video-tuerklingel": 1
      }
    }
  };

  // ##################################################################
  // ### END OF PRICE CONFIGURATION ###
  // ##################################################################


  // Check if all pages have at least one selected option or non-zero input
  function checkAllPages() {
    for (let i = 0; i < maxPageIndex; i++) {
      const anyButtonOn = Array.from(
        pages[i].querySelectorAll(".custom-on, .product-quantity")
      ).some(
        (input) =>
          input.classList.contains("custom-on") || input.value > 0
      );
      if (!anyButtonOn) {
        return false;
      }
    }
    return true;
  }

  // Initialize variables for the third button
  let isThirdButtonToggled = false;
  
  // Define the updateButtons function inside DOMContentLoaded
  function updateButtons() {
    akzeptierenButton.textContent =
      currentPageIndex === maxPageIndex ? "berechnen" : "weiter"; // [cite: 190]
    akzeptierenButton.classList.toggle(
      "abschicken-button",
      currentPageIndex === maxPageIndex
    ); // [cite: 191]
    zurückButton.disabled = currentPageIndex === 0; // [cite: 192]

    let anyButtonOnCurrentPage;
    if (currentPageIndex === maxPageIndex) {
      const zipCodeValue = document.getElementById("zipcode").value;
      anyButtonOnCurrentPage = zipCodeValue.trim() !== "";
      akzeptierenButton.disabled = !checkAllPages() || !anyButtonOnCurrentPage; // [cite: 194]
    } else {
      anyButtonOnCurrentPage = Array.from(
        pages[currentPageIndex].querySelectorAll(".custom-on, .product-quantity")
      ).some(
        (input) =>
          input.classList.contains("custom-on") || input.value > 0
      ); // [cite: 194]
      akzeptierenButton.disabled = !anyButtonOnCurrentPage; // [cite: 196]
    }

    updateProgressBar();
  }

  // Define the toggleThirdButton function inside DOMContentLoaded
  function toggleThirdButton(button) {
    button.classList.toggle("custom-on"); // [cite: 198]
    button.classList.toggle("custom-off");

    // Track whether the third button is toggled
    window.isThirdButtonToggled = button.classList.contains("custom-on"); // [cite: 199]

    // Call updateButtons after toggling
    updateButtons(); // [cite: 200]
  }

  // Assign functions to window object for global access
  window.toggleThirdButton = toggleThirdButton;
  window.updateButtons = updateButtons;
  
  // Update the width of the progress bar based on the current page index
  function updateProgressBar() {
    const progressPercent = ((currentPageIndex + 1) / pages.length) * 100; // [cite: 201]
    progressBar.style.width = `${progressPercent}%`; // [cite: 202]
  }

  /**
   * Helper function to sum an array of cost breakdown items.
   * @param {Array<Object>} breakdownArray - An array of objects, e.g., [{ label: "...", amount: 100 }]
   * @returns {number} - The sum of all 'amount' properties.
   */
  function sumBreakdown(breakdownArray) {
    return breakdownArray.reduce((total, item) => total + item.amount, 0);
  }

  /**
   * Calculates montage cost based on the number of products.
   * @param {number} totalProducts - The total number of products.
   * @param {Object} rates - The montageRates object from priceConfig.
   * @returns {Object} - An object { label, amount }.
   */
  function getMontageCost(totalProducts, rates) {
    let rateInfo;
    let amount = 0;

    if (totalProducts === 0) {
      return { label: "Keine Produkte", amount: 0 };
    }

    if (totalProducts === 1) {
      rateInfo = rates["1"]; // [cite: 249]
    } else if (totalProducts === 2) {
      rateInfo = rates["2"]; // [cite: 250]
    } else {
      rateInfo = rates["default"]; // [cite: 251]
    }

    if (rateInfo.perProduct) {
      amount = rateInfo.rate * totalProducts;
    } else {
      amount = rateInfo.rate;
    }

    return { label: rateInfo.label, amount: amount };
  }


  /**
   * NEW REFACTORED CALCULATION FUNCTION
   * Calculates all costs based on selections and the central priceConfig.
   * @returns {Object} - An object containing { totals, costBreakdown, productList, immobilieType, zipCode }
   */
  function calculateCosts() {
    // This object will store human-readable labels for each calculation
    const costBreakdown = {
      geraetekosten: [],
      montagekosten: [],
      pauschale: [],
      sdKarten: [],
    };
    
    // This object will store the final summed totals
    const totals = {
      geraetekosten: 0,
      montagekosten: 0,
      pauschale: 0,
      sdKarten: 0,
      total: 0,
    };

    let selectedProducts = {}; // e.g., { "ueberwachungskamera": 2, "video-tuerklingel": 1 }
    let productListForForm = []; // e.g., ["Kameras (x2)", "Videotürklingeln (x1)"]
    let totalProducts = 0; // [cite: 217]

    // Get the selected Immobilie type from Page 0
    let immobilieType = ""; // [cite: 215]
    let immobilieButton = document.querySelector("#property-type-selection .custom-toggle-button.custom-on p"); // [cite: 217]
    if (immobilieButton) {
      immobilieType = immobilieButton.textContent.trim(); // [cite: 219]
    } else {
      console.error("No Immobilie type selected"); // [cite: 220]
    }

    // Collect selected Bereiche (areas to monitor) on Page 2
    let selectedBereiche = []; // [cite: 222]
    document.querySelectorAll('.quest-page:nth-of-type(2) .custom-toggle-button.custom-on p').forEach((bereich) => {
        selectedBereiche.push(bereich.textContent.trim());
    });
    const bereicheString = selectedBereiche.join(", "); // [cite: 223]

    // Check if "Weiß nicht" is selected on page 3
    const thirdButtonToggled = window.isThirdButtonToggled; // [cite: 224]
    document.getElementById("input-weissnicht").value = thirdButtonToggled ? "true" : "false"; // [cite: 226]

    if (thirdButtonToggled) {
      // "Weiß nicht" is selected, use defaults from priceConfig
      const defaults = priceConfig.weissNichtDefaults[immobilieType];
      if (defaults) {
        selectedProducts = defaults;
      }
      // (Logic now driven by config object)
      
    } else {
      // "Weiß nicht" is NOT selected, read values from product inputs
      document.querySelectorAll('.product-quantity').forEach((input) => {
        const quantity = parseInt(input.value, 10) || 0; // [cite: 242]
        if (quantity > 0) {
          const handle = input.closest('.custom-toggle-button').getAttribute('data-handle');
          selectedProducts[handle] = (selectedProducts[handle] || 0) + quantity;
        }
      });
    }
    
    // --- Now, calculate all costs based on the 'selectedProducts' map ---

    for (const handle in selectedProducts) {
      const quantity = selectedProducts[handle];
      if (quantity > 0) {
        totalProducts += quantity;
        
        // Find product name and price
        const productElement = document.querySelector(`.cm-product-card[data-handle="${handle}"]`);
        const productName = productElement.querySelector('p').textContent.trim(); // [cite: 242]
        const price = priceConfig.productPrices[handle] || 0;
        
        // 1. Calculate Gerätekosten
        const lineTotal = price * quantity; // [cite: 242]
        costBreakdown.geraetekosten.push({
          label: `${quantity}x ${productName} @ ${price.toFixed(2)} €`,
          amount: lineTotal
        });
        
        // Add to product list for the form
        productListForForm.push(`${productName} (x${quantity})`); // [cite: 242]
      }
    }
    
    if (totalProducts > 0) {
      // 2. Calculate Pauschale
      // (Logic preserved)
      const pauschaleAmount = priceConfig.costs.pauschalePerProduct * totalProducts;
      costBreakdown.pauschale.push({
        label: `${totalProducts}x Produkte @ ${priceConfig.costs.pauschalePerProduct.toFixed(2)} €`,
        amount: pauschaleAmount
      });

      // 3. Calculate SD-Karten
      // (Price discrepancy logic preserved)
      const sdPrice = thirdButtonToggled ? priceConfig.costs.sdCardPriceWeissNicht : priceConfig.costs.sdCardPrice;
      const sdAmount = sdPrice * totalProducts;
      costBreakdown.sdKarten.push({
        label: `${totalProducts}x SD-Karten @ ${sdPrice.toFixed(2)} €`,
        amount: sdAmount
      });
    }

    // 4. Calculate Montagekosten
    // (Logic preserved)
    const montageResult = getMontageCost(totalProducts, priceConfig.montageRates);
    costBreakdown.montagekosten.push({
      label: montageResult.label,
      amount: montageResult.amount
    });

    // --- Sum all breakdowns to get final totals ---
    totals.geraetekosten = sumBreakdown(costBreakdown.geraetekosten); // [cite: 211]
    totals.montagekosten = sumBreakdown(costBreakdown.montagekosten); // [cite: 212]
    totals.pauschale = sumBreakdown(costBreakdown.pauschale); // [cite: 213]
    totals.sdKarten = sumBreakdown(costBreakdown.sdKarten); // [cite: 214]
    totals.total = totals.geraetekosten + totals.montagekosten + totals.pauschale + totals.sdKarten; // [cite: 253]
    
    // Get the ZIP code
    const zipCode = document.getElementById("zipcode").value.trim();

    return {
      totals,
      costBreakdown,
      productList: productListForForm.join(", "),
      bereicheString,
      immobilieType,
      zipCode
    };
  }
  
  
  /**
   * Updates all DOM elements (price display, hidden inputs) with calculated values.
   * @param {Object} calcData - The full object returned from calculateCosts()
   */
  function updateDomWithCosts(calcData) {
    const { totals, productList, bereicheString, immobilieType, zipCode } = calcData;

    // Update the UI with calculated costs
    document.getElementById("geraetekosten").textContent = `${totals.geraetekosten.toFixed(2)} €`;
    document.getElementById("montagekosten").textContent = `${totals.montagekosten.toFixed(2)} €`;
    document.getElementById("pauschale").textContent = `${totals.pauschale.toFixed(2)} €`; // [cite: 255]
    document.getElementById("sd-karten").textContent = `${totals.sdKarten.toFixed(2)} €`;
    document.getElementById("total").textContent = `${totals.total.toFixed(2)} €`;
    
    // Set hidden inputs for form submission
    document.getElementById("immobilie").value = immobilieType;
    document.getElementById("input-geraetekosten").value = totals.geraetekosten.toFixed(2);
    document.getElementById("input-montagekosten").value = totals.montagekosten.toFixed(2);
    document.getElementById("input-pauschale").value = totals.pauschale.toFixed(2);
    document.getElementById("input-sd-karten").value = totals.sdKarten.toFixed(2);
    document.getElementById("input-total").value = totals.total.toFixed(2);
    document.getElementById("input-produkte").value = productList;
    document.getElementById("input-bereiche").value = bereicheString;
    document.getElementById("input-zipcode").value = zipCode;
  }
  
  
  // Event listener for the "weiter" button
  akzeptierenButton.addEventListener("click", () => {
    if (currentPageIndex < maxPageIndex) {
      pages[currentPageIndex].classList.add("mc-hidden");
      currentPageIndex++;
      pages[currentPageIndex].classList.remove("mc-hidden");
    } else if (currentPageIndex === maxPageIndex) {
      // *** REFACTORED CALL ***
      const calcData = calculateCosts();
      
      // This is the "seperate segment" you asked for.
      // Open your browser's console (F12) to see a detailed breakdown.
      console.log("--- 📊 PRICE CALCULATION BREAKDOWN 📊 ---");
      console.log(calcData.costBreakdown);
      console.log("--- 🏁 TOTALS 🏁 ---");
      console.log(calcData.totals);
      
      updateDomWithCosts(calcData);
      
      // Save to local storage (Original functionality preserved)
      saveToLocalStorage(
        calcData.immobilieType,
        calcData.totals.geraetekosten,
        calcData.totals.montagekosten,
        calcData.totals.pauschale,
        calcData.totals.sdKarten,
        calcData.totals.total,
        calcData.bereicheString, 
        calcData.productList, 
        calcData.zipCode
      );

      pages[currentPageIndex].classList.add("mc-hidden");
      pages[pages.length - 1].classList.remove("mc-hidden"); // [cite: 204]
      document.querySelector(".mc-navigation").classList.add("mc-hidden");
      document
        .querySelector(".mc-progress-bar-container")
        .classList.add("mc-hidden");
    }
    updateButtons();
  });

  // Event listener for the "zurück" button
  zurückButton.addEventListener("click", () => {
    if (currentPageIndex > 0) {
      pages[currentPageIndex].classList.add("mc-hidden");
      currentPageIndex--;
      pages[currentPageIndex].classList.remove("mc-hidden");
    }
    updateButtons();
  });

  // Hide overlay with a transition
  document.getElementById("start-configurator").addEventListener("click", function () {
    const overlay = document.getElementById("start-overlay");
    overlay.classList.add("fade-out"); // 
    setTimeout(function () {
      overlay.style.display = "none";
    }, 300); // [cite: 207]
  });

  // Toggle button state
  window.toggleButton = function (button) {
    button.classList.toggle("custom-on");
    button.classList.toggle("custom-off");
    updateButtons();
  };

  // Ensure only one button can be "custom-on"
  window.toggleSingleButton = function (button) {
    const buttons = document.querySelectorAll(
      "#property-type-selection .custom-toggle-button"
    ); // [cite: 209]
    buttons.forEach((btn) => btn.classList.remove("custom-on"));
    button.classList.add("custom-on");
    updateButtons();
  };


  // Save form data to local storage (Original function)
  function saveToLocalStorage(immobilie, geraetekosten, montagekosten, pauschale, sdKarten, total, bereiche, produkte, zipCode) {
    localStorage.setItem('immobilie', immobilie); // [cite: 260]
    localStorage.setItem('geraetekosten', geraetekosten); // [cite: 260]
    localStorage.setItem('montagekosten', montagekosten); // [cite: 260]
    localStorage.setItem('pauschale', pauschale); // [cite: 260]
    localStorage.setItem('sdKarten', sdKarten); // [cite: 260]
    localStorage.setItem('total', total); // [cite: 260]
    localStorage.setItem('bereiche', bereiche); // [cite: 260, 263]
    localStorage.setItem('produkte', produkte); // [cite: 260, 263]
    localStorage.setItem('zipCode', zipCode); // [cite: 260]
  }

  // Load form data from local storage (Original function, never called)
  function loadFromLocalStorage() {
    const immobilie = localStorage.getItem('immobilie'); // [cite: 261]
    const geraetekosten = localStorage.getItem('geraetekosten'); // [cite: 262]
    const montagekosten = localStorage.getItem('montagekosten'); // [cite: 262]
    const pauschale = localStorage.getItem('pauschale'); // [cite: 262]
    const sdKarten = localStorage.getItem('sdKarten'); // [cite: 262]
    const total = localStorage.getItem('total'); // [cite: 262]
    const bereiche = localStorage.getItem('bereiche'); // [cite: 263] (Now reads string)
    const produkte = localStorage.getItem('produkte'); // [cite: 263] (Now reads string)
    const zipCode = localStorage.getItem('zipCode'); // [cite: 263]

    // (DOM updates)
    document.getElementById("geraetekosten").textContent = `Gerätekosten: €${parseFloat(geraetekosten).toFixed(2)}`; // [cite: 264]
    document.getElementById("montagekosten").textContent = `Montagekosten: €${parseFloat(montagekosten).toFixed(2)}`; // [cite: 264]
    document.getElementById("pauschale").textContent = `Pauschale Anschlussgebühr: €${parseFloat(pauschale).toFixed(2)}`; // [cite: 264]
    document.getElementById("sd-karten").textContent = `SD-Karten: €${parseFloat(sdKarten).toFixed(2)}`; // [cite: 264]
    document.getElementById("total").textContent = `Total: €${parseFloat(total).toFixed(2)}`; // [cite: 264]
  }

  // Reset form and local storage
  function reset() {
    currentPageIndex = 0; // [cite: 266]
    // Reset all pages to initial state
    pages.forEach((page, index) => {
      if (index === 0) {
        page.classList.remove("mc-hidden");
      } else {
        page.classList.add("mc-hidden");
      }
    });
    document.querySelector(".mc-navigation").classList.remove("mc-hidden"); // [cite: 268]
    document.querySelector(".mc-progress-bar-container").classList.remove("mc-hidden"); // [cite: 268]

    document.querySelectorAll(".custom-toggle-button").forEach((button) => {
      button.classList.remove("custom-on");
      button.classList.add("custom-off");
    });
    // Reset product quantities
    document.querySelectorAll('.product-quantity').forEach(input => {
      input.value = 0;
    });
    // Reset the zip code input
    document.getElementById('zipcode').value = '';
    // Reset the "Weiß nicht" toggle state
    window.isThirdButtonToggled = false;
    // Reset the form and clear local storage
    finalForm.reset();
    localStorage.clear(); // [cite: 274]
    // Hide success message and reset form UI
    successMessage.style.display = 'none';
    // Update buttons and progress bar
    updateButtons();
  }

  // 
  function resetFormAndReload() {
    reset();
    const url = new URL(window.location);
    url.searchParams.delete('contact_posted');
    window.location.href = url.href;
  }

  document.getElementById("reset-form-button").addEventListener("click", resetFormAndReload);

  resetButton.addEventListener("click", reset); // [cite: 278]
  
  // Event listeners for buttons
  document.querySelectorAll(".custom-toggle-button").forEach((button) => {
    button.addEventListener("click", () => {
      updateButtons();
    });
  });
  
  // Event listeners for quantity inputs
  document.querySelectorAll('.product-quantity').forEach(input => {
    input.addEventListener('input', (e) => {
      const quantity = parseInt(e.target.value, 10);
      const button = e.target.closest('.custom-toggle-button');
      if (quantity > 0) {
        button.classList.add('custom-on');
        button.classList.remove('custom-off');
      } else {
        button.classList.remove('custom-on');
        button.classList.add('custom-off');
      }
      updateButtons();
    });
  });
  
  // Event listener for zip code
  document.getElementById('zipcode').addEventListener('input', updateButtons);

  // Event listener for form submission
  finalForm.addEventListener('submit', (e) => {
    e.preventDefault(); // [cite: 280]
    
    // *** REFACTORED CALL ***
    // Recalculate just before submit to ensure data is fresh
    const calcData = calculateCosts(); // [cite: 280]
    updateDomWithCosts(calcData); // Update hidden inputs
    
    const url = new URL(window.location);
    url.searchParams.set('submitted', 'true');
    finalForm.action = url.href; // Update the form action with the new URL
    finalForm.submit(); // Submit the form after updating the URL
  });
  
  // Zip code length limit
  document.getElementById('zipcode').addEventListener('input', function (e) {
    if (this.value.length > 5) {
      this.value = this.value.slice(0, 5);
    }
  });
  
  // Initial button state update
  updateButtons();

  // Check for URL parameters to display success message
  const urlParams = new URLSearchParams(window.location.search);
  const successMessage = document.getElementById("submission-success");
  if (urlParams.has('contact_posted')) {
    successMessage.style.display = 'flex';
  }
});
